/**
 * F-0527: where a person's view choices are kept in `localStorage`, `<prefix><user>:<scope>`. Apart
 * from `viewChoicesSync.ts` so that `ViewChoicesStore`, made at boot, can name the keys without the
 * sync's code in the entry chunk (T-0559).
 */
export const VIEW_CHOICES_STORAGE_PREFIX = 'featit:viewChoices:v1:';
